import React from 'react';
import '../styles/PoliticaDatos.css';

const PoliticaDatos = () => {
  return (
    <div className="politica-container">
      <div className='tituloP'>Información relativa a la protección de datos.</div>

      <p>
        Usted autoriza expresamente al uso y tratamiento de sus datos
        personales necesarios, los cuales serán tratados y protegidos conforme a la Ley Orgánica 3/2018, de 5 de
        diciembre, de Protección de datos y garantía de los derechos digitales, y su normativa de desarrollo, así como
        el Reglamento Europeo 2016/679 del Parlamento europeo y del Consejo de 27 de abril 2016, relativo a la
        protección de las personas físicas en lo que respecta al tratamiento de datos personales y a la libre
        circulación de estos datos.
      </p>
      <p>
        Puede ejercitar sus derechos de acceso, rectificación, supresión, limitación, portabilidad y oposición al
        tratamiento por correo electrónico a la dirección <a href="mailto:alayievents@gmail.com">alayievents@gmail.com</a>.
      </p>
    </div>
  );
};

export default PoliticaDatos;